const main_data = {
    key_interfaz: "tabla_costos",
    key_esquema: "COSTOS",
    module: "costos"
}

module.exports = {
    main_data
}